











import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ButtonToggle } from '@/components/molecules/ButtonToggle'
import { IButtonToggleItem } from '@/components/molecules/ButtonToggle/ButtonToggle.type'

@Component({
  components: { ButtonToggle }
})
export default class ReservedCollectionButtonToggle extends ComponentVue {
  @Prop({
    type: String
  })
  activeToggleItem!: string

  toggleItems: IButtonToggleItem[] = [
    { value: '1', text: '予約中' },
    { value: '2', text: '予約取消' }
  ]

  get _activeToggleItem(): string {
    return this.activeToggleItem
  }

  set _activeToggleItem(value: string) {
    this.$emit('toggle', value)
  }
}
